module.exports = __webpack_public_path__ + "static/media/proakt-web.707d8d10.png";